import PropTypes from 'prop-types';

export default () => ({
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  restProps: PropTypes.any,
});
